module.exports = __webpack_public_path__ + "assets/01582ffe3d5f09afe470130016aa3b92.png";